import React, { useState } from 'react';
import styled from 'styled-components/macro';
import BaseOverlay, { BaseOverlayProps } from './BaseOverlay';
import { useDispatch, useSelector } from 'react-redux';
import { assignUnassignActions, ticketActions } from 'store/actions';
import { history } from 'store/helpers';
import { userDataSelector } from 'store/selectors';
interface NoteOverlayProps extends BaseOverlayProps {}
const NoteOverlay: React.FC<NoteOverlayProps> = (props) => {
  const name = 'Note';
  const dispatch = useDispatch();
  const propsFromDispatchSelector = (state) =>
    state.showOverlay[name] || {};
  const propsFromDispatch = useSelector(propsFromDispatchSelector);
  const { open, handleClose: handleCloseFromProps, title } = props;
  const handleClose = () => {
    handleCloseFromProps();
  };
  const [note, setNote] = useState<string>('');
  const user = useSelector(userDataSelector);
  const addNoteUnassign = async () => {
    const {
      ticketId,
      status /* time tracking status*/,
      durationInSeconds,
    } = propsFromDispatch;
    if (!ticketId) {
      console.error('ticketId is missing so do not proceed');
    }
    const callPostTimeTracking = async (_id) =>
      ticketActions.postTimeTracking(
        _id,
        user?.email,
        status,
        durationInSeconds > 0 ? durationInSeconds : 0,
        note,
        false,
      );
    if (Array.isArray(ticketId)) {
      // for unassign from bulk action of which the note is shown in postUnassignOfSelectedTicketIds action
      await Promise.all(
        ticketId.map((_id) => callPostTimeTracking(_id)),
      );
    } else {
      await callPostTimeTracking(ticketId);
      dispatch(
        assignUnassignActions.postUnassignTicket(
          ticketId,
          true, // save before unassign (because after unassign the save will fail on unmount)
        ),
      );
      history.push(`/workdesk`);
    }
  };
  const handleConfirmClicked = async () => {
    const { handleOnClick, ticketId } = propsFromDispatch;
    await addNoteUnassign();
    handleClose();
    if (handleOnClick) {
      handleOnClick(ticketId);
    }
  };
  return (
    <BaseOverlay
      open={open}
      handleClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      title={title}
      height={'40%'}
    >
      <SContainer>
        <SText>Please give a reason for unassign.</SText>
        <STextarea
          onChange={(e) => setNote(e.target.value)}
        ></STextarea>

        <SButtonContainer>
          <SButton
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </SButton>
          <SButton onClick={handleConfirmClicked}>Confirm</SButton>
        </SButtonContainer>
      </SContainer>
    </BaseOverlay>
  );
};

export default NoteOverlay;
const SText = styled.div`
  color: #808080;
`;
const SButtonContainer = styled.div`
  display: flex;
  width: 90%;
  justify-content: flex-end;
`;
const SContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0 20px;
`;
const STextarea = styled.textarea`
  height: 50%;
  width: 90%;
  resize: none;
  border-radius: 10px;
  border: #fafafa;
  background-color: #e4e4e4;
  padding: 10px;
  font-size: large;
`;
const SButton = styled.div`
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
`;
